var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPopupLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 11.25V26.25H1.25V11.25H6.25ZM11.25 26.25C10.587 26.25 9.95107 25.9866 9.48223 25.5178C9.01339 25.0489 8.75 24.413 8.75 23.75V11.25C8.75 10.5625 9.025 9.9375 9.4875 9.4875L17.7125 1.25L19.0375 2.575C19.375 2.9125 19.5875 3.375 19.5875 3.8875L19.55 4.2875L18.3625 10H26.25C26.913 10 27.5489 10.2634 28.0178 10.7322C28.4866 11.2011 28.75 11.837 28.75 12.5V15C28.75 15.325 28.6875 15.625 28.575 15.9125L24.8 24.725C24.425 25.625 23.5375 26.25 22.5 26.25H11.25ZM11.25 23.75H22.5375L26.25 15V12.5H15.2625L16.675 5.85L11.25 11.2875V23.75Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopupLike);
export default __webpack_public_path__ + "static/media/popupLike.b701c7d0aedbb07f91af260510f8ed57.svg";
export { ForwardRef as ReactComponent };